import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { GlgSelect } from 'SharedComponents'
import ReactDOMServer from 'react-dom/server'
import LabeledInput from './event_setup/labeled_input'
import { filterSelectableDefaultTees, filterTeesByGender } from './event_setup/tee_filtering'


class EventSetupPairings extends Component {
  constructor(props){
    super(props)
    this.state = {
      dataChanged: false,
    }
  }

  componentDidUpdate(prevProps) {
    if ((this.props.content.data !== prevProps.content.data && this.props.content.dataChanged) || this.state.dataChanged) {
      this.props.save()
      this.setState({dataChanged: false})
    }
  }

  render() {
    const { title, data } = this.props.content
    const setter = (keys) => (value) => this.props.setData([ 'data' ].concat(keys), value)

    const coursesTees = data.courses_tees
    const selectedCourse = 'default_courses' in coursesTees ?
      coursesTees.default_courses[coursesTees.variable_settings_default_course] : null
    const allTeesForCourse = Object.values(selectedCourse?.tees || {})
    const teesForDefaultCourse = filterSelectableDefaultTees(allTeesForCourse, selectedCourse?.holes)

    // The league edit page allows any tee for any gender/hole combination, so
    // the saved tee may fall outside the filtered list. Pin it into the options
    // so the dropdown shows the real selection instead of a filtered substitute.
    const withSelectedTee = (genderTees, selectedValue) => {
      if (!selectedValue || genderTees.some(tee => tee.value === selectedValue)) { return genderTees }
      const selectedTee = allTeesForCourse.find(tee => tee.value === selectedValue)
      return selectedTee ? [ ...genderTees, selectedTee ] : genderTees
    }

    const maleTees = withSelectedTee(filterTeesByGender(teesForDefaultCourse, "Male"), coursesTees.variable_settings_default_tee_m)
    const femaleTees = withSelectedTee(filterTeesByGender(teesForDefaultCourse, "Female"), coursesTees.variable_settings_default_tee_f)

    const noCoursesLabel = (
      <label className='courses-not-found'>
        <div dangerouslySetInnerHTML={{
          __html: window.I18n.t(
          'pairings.set_course.set_courses_html',
          { href: ReactDOMServer.renderToString(<a href={coursesTees.courses_url} className='blue-normal'>{window.I18n.t('pairings.set_course.here')}</a>) }),
          }} />
      </label>
    )

    return (
      <div className='widget-content-default widget-event-setup-pairings'>
        <div className='title'>
          { title }
        </div>

        <div className='content flex-list-layout'>
          <ul>
            <li>
              <LabeledInput label={ data.pairing_group_size.label } childrenClass='wide' >
                <GlgSelect
                  items={ data.pairing_group_size.options }
                  value={ data.pairing_group_size.value }
                  onChange={ this.props.setPairingGroupSize } />
              </LabeledInput>
            </li>


            {
              data.pairing_group_size.value !== 1 && 'pairing_groups_count' in data ?
                <>
                  <li>
                    <LabeledInput label={ data.pairing_groups_count.label } childrenClass='narrow' >
                      <input
                        className='number-of-pairing-groups form-control'
                        value={ data.pairing_groups_count.value }
                        onChange={ e => setter([ 'pairing_groups_count', 'value' ])(e.target.value) }
                        onBlur={ e => setter([ 'pairing_groups_count', 'value' ])(parseInt(e.target.value) || 0) }
                      />
                    </LabeledInput>
                  </li>
                  
                </>
                :
                null
            }

            {
              'default_courses' in coursesTees ?
                <>
                  <>
                    <li>
                      <LabeledInput label={ coursesTees.label_default_course } childrenClass='wide' >
                        <GlgSelect
                          items={ Object.values(coursesTees.default_courses) }
                          placeholder="Select a course"
                          value={ coursesTees.variable_settings_default_course }
                          noPreFill={true}
                          onChange={ this.props.setCourseTee } />
                      </LabeledInput>
                    </li>

                  {
                    !$.isEmptyObject(coursesTees.default_courses) &&
                      <li>
                        <LabeledInput diffKey='no-teesheet-number-of-holes' label={ coursesTees.label_holes } childrenClass='wide'>
                                <GlgSelect
                                  items={ Object.values(coursesTees.default_courses[coursesTees.variable_settings_default_course]?.holes || {}) }
                                  value={ coursesTees.variable_settings_hole_type }
                                  onChange={ this.props.setHole } />
                              </LabeledInput>
                      </li>
                  }

                    <li>
                      <LabeledInput className='default-tee-by-gender' diffKey='no-teesheet-number-of-holes' label={ coursesTees.label_default_tee_by_gender } childrenClass='wider'>
                        <>
                          <div className='tee-by-gender'>
                            <label className='font-weight-normal'>M</label>
                            <GlgSelect
                              items={ maleTees }
                              value={ coursesTees.variable_settings_default_tee_m }
                              ignoreEmptyList={ false }
                              noPreFill={ true }
                              onChange={ setter([ 'courses_tees', 'variable_settings_default_tee_m' ]) }
                              usePortal={ teesForDefaultCourse.length > 5 }
                              menuShouldBlockScroll={ teesForDefaultCourse.length > 5 }
                              menuPlacement='bottom' />
                          </div>

                          <div className='tee-by-gender'>
                            <label className='font-weight-normal'>F</label>
                            <GlgSelect
                              items={ femaleTees }
                              value={ coursesTees.variable_settings_default_tee_f }
                              ignoreEmptyList={ false }
                              noPreFill={ true }
                              onChange={ setter([ 'courses_tees', 'variable_settings_default_tee_f' ]) }
                              usePortal={ teesForDefaultCourse.length > 5 }
                              menuShouldBlockScroll={ teesForDefaultCourse.length > 5 }
                              menuPlacement='bottom' />
                          </div>
                        </>
                      </LabeledInput>
                    </li>
                  </>

                  <li>
                    <div className='checkbox-options'>
                      <b>{ data.course_selection.label }</b>
                      <div className='checkbox-container vertical'>

                        <label className='icheck-label' htmlFor='allow_players_from_mobile'>
                          <div className={`icheckbox_square-orange icheck-item ${data.course_selection.allow_players_from_mobile.selected ? 'checked' : ''}`}>
                            <input
                              id='allow_players_from_mobile'
                              className='i-checks icheck-input'
                              type='checkbox'
                              value={data.course_selection.allow_players_from_mobile.selected}
                              checked={data.course_selection.allow_players_from_mobile.selected}
                              onChange={event => setter([ 'course_selection', 'allow_players_from_mobile', 'selected' ])(event.target.checked)}
                            />
                          </div>
                          <span>{data.course_selection.allow_players_from_mobile.label}</span>
                        </label>

                        {
                          data.course_selection.allow_players_from_mobile.selected && data.course_selection.attester_required &&
                            <label className='icheck-label' htmlFor='attester_required'>
                              <div className={`icheckbox_square-orange icheck-item ${data.course_selection.attester_required.selected ? 'checked' : ''}`}>
                                <input
                                  id='attester_required'
                                  className='i-checks icheck-input'
                                  type='checkbox'
                                  value={data.course_selection.attester_required.selected}
                                  checked={data.course_selection.attester_required.selected}
                                  onChange={event => setter([ 'course_selection', 'attester_required', 'selected' ])(event.target.checked)}
                                />
                              </div>
                              <span>{data.course_selection.attester_required.label}</span>
                            </label>
                        }

                      </div>
                    </div>
                  </li>
                </>

              : 
                <li> { noCoursesLabel } </li>
            }
          </ul>
        </div>

      </div>
    )
  }
}

EventSetupPairings.propTypes = {
  content: PropTypes.object,
  setData: PropTypes.func,
  setHole: PropTypes.func,
  setCourseTee: PropTypes.func,
  setPairingGroupSize: PropTypes.func,
  save: PropTypes.func,
}

EventSetupPairings.defaultProps = {
  content: {
    title: 'PAIRINGS',
    data: {},
  },
}

export default EventSetupPairings

